/**
 * Renders text for pagination label
 */
export default {
	methods: {
		getPaginationLabel(firstRowIndex, endRowIndex, totalRowsNumber) {
			return `${firstRowIndex} - ${endRowIndex} ${this.$t('table.paginationLabel')} ${totalRowsNumber}`;
		}
	}
}